import request from "@/utils/request.js";

/**
 * 获取机构
 * @returns {AxiosPromise}
 */
export function getStudentMessage(params) {
  return request({
    url: "/coreService/api/app/student/getStudentMessage",
    method: "post",
    data: params
  });
}
/**
 * 获取机构
 * @returns {AxiosPromise}
 */
export function update(params) {
  return request({
    url: "/coreService/api/app/student/update",
    method: "post",
    data: params
  });
}
/**
 * 是否展示证书菜单，获取用户学习情况
 * @returns {AxiosPromise}
 */
export function getUserStudyInfo() {
  return request({
    url: "/coreService/api/app/userCourse/getUserStudyInfo",
    method: "post"
  });
}
